import getAxiosClient from "../config/axios";

const AlertNotificationApiClient = {
    getPendingPopups: () => getAxiosClient().get('/api/popups/pending'),
};

export default AlertNotificationApiClient;
